import { useLayoutEffect, useRef } from 'react'

import { useGSAP } from '@/composables/useGSAP'

export type LoadingExitSwirlProps = {
  delay?: number
}

export default function LoadingExitSwirl({ delay = 0.5 }: LoadingExitSwirlProps) {
  const { gsap } = useGSAP()

  const pathOut1Ref = useRef<SVGPathElement>(null)
  const pathOut2Ref = useRef<SVGPathElement>(null)

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      gsap
        .timeline()
        .addLabel('path', delay)
        .fromTo(
          [pathOut1Ref.current, pathOut2Ref.current],
          {
            drawSVG: '0% 0%',
          },
          {
            drawSVG: '0% 100%',
            duration: 0.4,
            stagger: 0.15,
            ease: 'power1.in',
          },
          'path'
        )
        .to(
          [pathOut2Ref.current, pathOut1Ref.current],
          {
            drawSVG: '100% 100%',
            duration: 0.4,
            stagger: 0.15,
            ease: 'power1.inOut',
          },
          'path+=1'
        )
    })

    return () => ctx.kill()
  }, [delay, pathOut1Ref, pathOut2Ref, gsap])

  return (
    <svg
      className={`absolute top-1/2 -translate-y-1/2 right-0 w-[41.111vw]`}
      viewBox='0 0 592 844'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        ref={pathOut1Ref}
        d='M15.9994 430C247.484 301.397 452.569 554.414 594 617.5'
        stroke='currentColor'
        strokeWidth='1.5'
        className='opacity-30'
      />
      <path
        ref={pathOut2Ref}
        d='M15.9994 430C247.484 301.397 452.569 554.414 594 617.5'
        stroke='currentColor'
        strokeWidth='1.5'
        className='opacity-100'
      />
    </svg>
  )
}
